// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__FL4gW","rootSuccess":"CompleteLink_rootSuccess__31s__","rootFailure":"CompleteLink_rootFailure__1ZP54","isDisabled":"CompleteLink_isDisabled__1fANQ"};